import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { Flyout } from '@els/els-react--flyout';

import './HoverTooltip.scss';

export default function HoverTooltip({
  id,
  tooltip,
  children,
  className,
  width,
  tag,
  tooltipPlace,
  theme,
  isDisabled,
  trigger,
  modifiers,
  onToggle,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const Tag = tag ? `${tag}` : 'div';
  // eslint-disable-next-line custom/no-unsafe-deep-access
  const tooltipTrigger = React.Children.toArray(children).filter(Boolean);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleEscapeKey = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
      }
    };

    document.addEventListener('keydown', handleEscapeKey, true);
    return () => document.removeEventListener('keydown', handleEscapeKey, true);
  }, [isOpen]);

  const handleToggle = (open) => {
    setIsOpen(open);
    if (onToggle) onToggle(open);
  };

  return tooltip ? (
    <Flyout
      placement={tooltipPlace || 'top-start'}
      trigger={trigger || 'hover'}
      width={width || 'max-content'}
      theme={theme || 'default'}
      isDisabled={isDisabled || false}
      id={id}
      pointerType="primary"
      className={className}
      flyout={<Tag dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(tooltip) }} />}
      modifiers={modifiers}
      shouldCloseOnESC
      onToggle={handleToggle}>
      {tooltipTrigger}
    </Flyout>
  ) : (
    <div className={className}>{tooltipTrigger}</div>
  );
}

HoverTooltip.propTypes = {
  id: PropTypes.string,
  tooltip: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.string,
  isDisabled: PropTypes.bool,
  tag: PropTypes.string,
  trigger: PropTypes.string,
  tooltipPlace: PropTypes.string,
  modifiers: PropTypes.array,
  onToggle: PropTypes.func,
};
